// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-pie svg{transform:scale(1.15)}.chart-pie text.nv-pie-title{font-weight:700}.chart-pie-extra{display:flex;justify-content:space-between;margin-bottom:15px}.chart-pie-extra:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
